"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateNominalApplicationFeeAmount = void 0;
const utils_1 = require("../../utils");
/**
 * Calculates the nominal application fee amount for a transaction
 *
 * @param {Object} params - Parameters required for the calculation.
 * @param {number} params.transactionAmount - The original transaction amount.
 * @param {number} params.applicationFee - The base Deed application fee rate (as a percentage) for a non-recurring donation without covering fee.
 * @param {number} params.maxApplicationFeeAmount - The maximum allowable application fee amount.
 * @returns {number} The calculated nominal application fee amount, rounded to two decimal places.
 */
const calculateNominalApplicationFeeAmount = ({ transactionAmount, applicationFee, maxApplicationFeeAmount, }) => {
    // Calculate the base application fee amount.
    const rawApplicationFeeAmount = transactionAmount * (applicationFee / 100);
    // Apply caps to both fee types
    const cappedApplicationFeeAmount = Math.min(rawApplicationFeeAmount, maxApplicationFeeAmount);
    // Round and return the final fee amount
    return (0, utils_1.roundNumber)(cappedApplicationFeeAmount);
};
exports.calculateNominalApplicationFeeAmount = calculateNominalApplicationFeeAmount;
//# sourceMappingURL=calculateNominalApplicationFeeAmount.js.map